import { render, staticRenderFns } from "./SportsRiskReport.vue?vue&type=template&id=7f476d93&"
import script from "./SportsRiskReport.vue?vue&type=script&lang=js&"
export * from "./SportsRiskReport.vue?vue&type=script&lang=js&"
import style0 from "./SportsRiskReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports